export enum PriceType {
            fixed = 'fixed'
}
